import {BasicContentPage, getServerSidePropsTemplate} from '@@client/components/BasicContentPage'
import {getTrimCodesPageContent} from '@@client/content/api'

export default BasicContentPage

export const getServerSideProps = getServerSidePropsTemplate(getTrimCodesPageContent)
